import {
  BsPerson,
  BsFileEarmarkSpreadsheet,
  BsHouseDoor,
} from "../../assets/icons/vander";
import { TopHeader } from "../components/utils";
import { PatientSurgeryTable } from "../components/tables";
import { PatientSurgerySearchForm } from "../components/forms";
import { DailyAssessmentCard, IndicatorsCard } from "../components/cards";
import { DashboardCalendar } from "../components/calendars";
import { DoctorLayout } from "../layout";

const Nav = () => {
  return (
    <nav aria-label="breadcrumb" className="d-inline-block">
      <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
        <li className="breadcrumb-item active" aria-current="page">
          <BsHouseDoor className="icons-sm" /> Dashboard
        </li>
      </ul>
    </nav>
  );
};

export const MainPage = () => {
  return (
    <DoctorLayout>
      <TopHeader Nav={Nav} />

      {/* FILA SUPERIOR */}
      <h1>Dashboard</h1>
      <div className="dashboard-grid">
        <div className="grid-column-left">
          <div className="grid-item-main">
            <div className="row row-cols-1 row-cols-sm-2 gy-3">
              <div className="col">
                <IndicatorsCard
                  title="Valoraciones"
                  number={12}
                  icon={<BsFileEarmarkSpreadsheet className="icons" />}
                />
              </div>
              <div className="col">
                <IndicatorsCard
                  title="Pacientes"
                  number={54}
                  icon={<BsPerson className="icons" />}
                />
              </div>
            </div>
          </div>

          <div className="grid-item-patients">
            <h3>Pacientes</h3>
            <div className="d-flex flex-column gap-3">
              <PatientSurgerySearchForm />
              <PatientSurgeryTable />
            </div>
          </div>
        </div>

        <div className="grid-column-right">
          <div className="grid-item-calendar">
            <DashboardCalendar />
          </div>

          <div className="grid-item-daily">
            <DailyAssessmentCard />
          </div>
        </div>
      </div>
    </DoctorLayout>
  );
};
